// extracted by mini-css-extract-plugin
export default {"traits":"Traits-module__traits__2wYmt","header":"Traits-module__header__CIDts","title":"Traits-module__title__73uYz"};